import { createI18n } from 'vue-i18n';
import cn from './config/cn.js';
import en from './config/en.js';
import en_gb from './config/en_gb.js';
import ko from './config/ko.js';
import ru from './config/ru.js';
import zhLocale from 'element-plus/dist/locale/zh-cn.mjs';
import enLocale from 'element-plus/dist/locale/en.mjs';
import en_gbLocale from 'element-plus/dist/locale/en.mjs';
import koLocale from 'element-plus/dist/locale/ko.mjs';
import ruLocale from 'element-plus/dist/locale/ru.mjs';

// 用户自定义多语言内容
let customCN = window.customCN
let customEN = window.customEN
let customEN_GB = window.customEN_GB
let customKO = window.customKO
let customRU = window.customRU


const messages = {};
const element = { en: enLocale, 'en_gb': en_gbLocale, 'zh-cn': zhLocale, ko: koLocale, ru: ruLocale };
const itemize = {
    en: [Object.assign(en, customEN)],
    'en_gb': [Object.assign(en_gb, customEN_GB)],
    'zh-cn': [Object.assign(cn, customCN)],
    ko: [Object.assign(ko, customKO)],
    ru: [Object.assign(ru, customRU)]
};



// 合并数组对象（非标准数组对象，数组中对象的每项 key、value 都不同）
function mergeArrObj(list, key) {
    let obj = {};
    list[key].forEach((i) => {
        obj = Object.assign({}, obj, i);
    });
    return obj;
}
// 处理最终格式
for (const key in itemize) {
    messages[key] = {
        name: key,
        el: element[key].el,
        // message: mergeArrObj(itemize, key),
    };
    messages[key] = Object.assign(messages[key], mergeArrObj(itemize, key))
}
const i18n = createI18n({
    legacy: false,
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true,
    fallbackWarn: false,
    locale: localStorage.getItem('lang') || 'zh-cn', // 设置默认语言
    messages, // 设置翻译内容
})

export default i18n